"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const lp_redux_api_1 = require("lp-redux-api");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const reducer_1 = require("../../reducer");
const actions = __importStar(require("../actions"));
const UserForm_1 = __importDefault(require("../forms/UserForm"));
const reducer_2 = require("../reducer");
function UserAdd({ newManager, updateManager, getManagerById, managerById, clearMangerById, loading, allLocations, }) {
    const { id } = (0, react_router_dom_1.useParams)();
    const history = (0, react_router_dom_1.useHistory)();
    const [initialValues, setInitialValues] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        if (id) {
            getManagerById(id);
        }
        else {
            setInitialValues({
                status: 'active',
                selectAllPermissions: true,
                permissions: config_1.DEFAULT_PERMISSIONS_KEYS,
            });
        }
        return () => clearMangerById();
    }, [id]);
    (0, react_1.useEffect)(() => {
        if (managerById) {
            const { managerId, email, firstName, lastName, locationPermissions, assignedLocationIds, status, } = managerById;
            const locationPermission = (0, lodash_1.first)(locationPermissions);
            const permission = locationPermission && Object.keys(locationPermission);
            const assignedLocations = assignedLocationIds
                .map((locId) => {
                const { name, adsStoreNumber, locationId } = allLocations.find((al) => al.locationId === locId) || {};
                return name
                    ? {
                        label: `${name}, ${adsStoreNumber}`,
                        value: locationId,
                    }
                    : null;
            })
                .filter((n) => n);
            setInitialValues({
                managerId,
                firstName,
                lastName,
                email,
                assignedLocationIds: assignedLocations,
                status,
                selectAllPermissions: true,
                adminPermissions: permission?.filter((key) => config_1.ADMIN_PERMISSION_KEYS.includes(key) &&
                    locationPermission &&
                    locationPermission[key] === true),
                permissions: permission?.filter((key) => config_1.DEFAULT_PERMISSIONS_KEYS.includes(key) &&
                    locationPermission &&
                    locationPermission[key] === true),
            });
        }
    }, [managerById]);
    const handleSubmit = (values) => {
        const data = {
            ...values,
            active: values.status === 'active' ? true : false,
            permissions: parseSelectedPermission(values.permissions),
            assignedLocationIds: parseSelectedLocations(values.assignedLocationIds),
            email: values.email,
        };
        if (!id) {
            return newManager(data);
        }
        return updateManager(data);
    };
    const handleSubmitSuccess = () => {
        (0, utils_1.toastSuccess)(id ? 'User Successfully Updated' : 'User Successfully Created');
        history.push(config_1.USER_URL);
    };
    if (id && loading) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    }
    if (id && (0, lodash_1.isUndefined)(managerById)) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Error Fetching User Detail" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", children: "GO HOME" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "account-lookup full-application users-add m-t-50", children: [(0, jsx_runtime_1.jsxs)(components_1.H1, { variant: "headline-large", children: [id ? 'Update' : 'New', " User Account"] }), (0, jsx_runtime_1.jsx)(UserForm_1.default, { initialValues: initialValues, onSubmit: handleSubmit, onSubmitFail: utils_1.flashSubmitFailure, onSubmitSuccess: handleSubmitSuccess })] }));
}
function mapStateToProps(state) {
    return {
        managerById: reducer_2.selectors.managerById(state),
        loading: lp_redux_api_1.selectors.isLoading(state, 'GET_MANAGER_BY_ID'),
        allLocations: reducer_1.selectors.allLocations(state),
    };
}
const mapDispatchToProps = {
    clearMangerById: actions.clearMangerById,
};
const mapApiAuthToProps = {
    newManager: apiActions.newManager,
    updateManager: apiActions.updateManager,
    getManagerById: apiActions.getManagerById,
};
const parseSelectedPermission = (selectedPermissions) => {
    const permissions = config_1.DEFAULT_PERMISSIONS;
    Object.keys(permissions).forEach((key) => {
        permissions[key] = false;
    });
    //only makes selected permissions 'true'
    selectedPermissions.forEach((selectedPerm) => {
        permissions[selectedPerm] = true;
    });
    return permissions;
};
function parseSelectedLocations(values) {
    return values.map(({ value }) => Number(value));
}
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(UserAdd);
